import React from 'react';
import './roller.css';

const Roller = () => (
  <div className="d-flex justify-content-center align-items-center h-100">
    <div className="lds-roller m-auto">
      <div className="primary-bg" />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
    </div>
  </div>
);

export default Roller;
